export default "__VITE_ASSET__eYddP3i8__"